import { dictionary } from "../utils/dictionary";
import { useAuth } from "../context/AuthContext";
import { ConfigurationPanel } from "../components/preferences/ConfigPanel";

export default function UserPreferences() {
  const { language } = useAuth();

  return (
    <div className="fixed inset-0 z-[9999] min-h-screen bg-[#F5F6FA] flex flex-col items-center justify-center font-['Plus_Jakarta_Sans',sans-serif] text-center px-6">
      {/* Background Gradient */}
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(62, 62, 255, 0) 0%, rgba(62, 110, 255, 0.2) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      />

      <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-24 relative z-10 h-full py-10">
        {/* Left Side: Welcome & Logo */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-md animate-in slide-in-from-left duration-500">
          <div className="relative w-28 h-28 md:w-32 md:h-32 mb-2">
            <img
              src="https://fluxi.s3.amazonaws.com/prod/assets/images/fluxi-head"
              alt="Fluxi Logo"
              className="w-full h-full object-contain"
            />
          </div>

          <div className="space-y-2">
            <h1 className="text-4xl md:text-5xl font-medium text-slate-900">
              {dictionary["welcome-to"][language]} <br />
              <img
                src="https://fluxi.s3.amazonaws.com/prod/assets/fluxi/fluxi-logo.svg"
                alt=""
              />
            </h1>
            <p className="text-lg text-slate-600 max-w-xs mx-auto lg:mx-0 leading-relaxed pt-4">
              {dictionary["configure-your-account-in-a-few-moments"][language]}
            </p>
          </div>
        </div>

        {/* Right Side: The Wizard Panel */}
        <ConfigurationPanel />
      </div>
    </div>
  );
}
